export default __webpack_public_path__ + "static/media/Dazzed-Regular.123be24d.otf";